let workspace: number | null = null;

export const setGlobalWorkspace = (newWorkspace: number) => {
  workspace = newWorkspace;
};

export const getGlobalWorkspace = () => {
  return workspace;
};
